import {
  hasTreasuryOnboardingAccess,
  hasTreasuryTroubleshootingAccess,
  isTreasuryPlatformManager,
} from "~/utils/userRoles";
import { ToolCategory } from "./types";

export const GLOBAL_TOOL_CATEGORIES: ToolCategory[] = [
  {
    title: "Manual overrides",
    tools: [
      {
        title: "Cancel payment batch",
        description: "Stop processing immediately",
        path: "/treasury/configuration/cancel-payment-batch",
        iconType: "ban",
        checkPermission: hasTreasuryTroubleshootingAccess,
      },
      {
        title: "Recreate outgoing payments",
        description: "",
        path: "/treasury/configuration/recreate-outgoing-payments",
        iconType: "money-bill-transfer",
        checkPermission: hasTreasuryTroubleshootingAccess,
      },
      {
        title: "Modify Payment Status",
        description: "Update status of payment",
        path: "/treasury/configuration/modify-payment-status",
        iconType: "sort-alt",
        checkPermission: hasTreasuryTroubleshootingAccess,
      },
    ],
  },
  {
    title: "Diagnostics & logs",
    tools: [
      {
        title: "Query payment batch",
        description: "Check status and raw logs",
        path: "/treasury/configuration/query-payment-batch",
        iconType: "file",
        checkPermission: isTreasuryPlatformManager,
      },
      {
        title: "Query processing payments",
        description: "Check processing payments with confirmation status",
        path: "/treasury/configuration/query-processing-payments",
        iconType: "search",
        checkPermission: isTreasuryPlatformManager,
      },
      {
        title: "Query provider object",
        description: "Inspect specific provider data",
        path: "/treasury/configuration/query-provider-object",
        iconType: "search",
        checkPermission: isTreasuryPlatformManager,
      },
    ],
  },
];

export const PROVIDER_TOOL_CATEGORIES: ToolCategory[] = [
  {
    title: "GPx payments (CRB)",
    tools: [
      {
        title: "Set bank account verification status",
        description: "Force status update",
        path: "/treasury/configuration/set-bank-account-verification-status",
        iconType: "check-circle",
        checkPermission: hasTreasuryOnboardingAccess,
      },
      {
        title: "Manual reconciliation",
        description: "Link EP and IPD",
        path: "/treasury/configuration/link-ep-and-ipd",
        iconType: "link-horizontal",
        checkPermission: isTreasuryPlatformManager,
      },
      {
        title: "Reconciliation gaps",
        description: "Check wire batches for potential issues",
        path: "/treasury/configuration/reconciliation-gaps",
        iconType: "repeat",
        checkPermission: hasTreasuryTroubleshootingAccess,
      },
    ],
  },
];

export const FIDES_TOOL_CATEGORY: ToolCategory = {
  title: "FA treasury (Fides)",
  tools: [
    {
      title: "Bank account configuration",
      description: "View and manage bank account connectivity settings",
      path: "/treasury/configuration/bank-accounts",
      iconType: "plus",
      checkPermission: hasTreasuryOnboardingAccess,
    },
    {
      title: "Onboard bank account",
      description: "",
      path: "/treasury/configuration/onboard-bank-account",
      iconType: "plus",
      checkPermission: hasTreasuryOnboardingAccess,
    },
  ],
};
